
export { default as window } from "./main3.js"